import { Point } from '../components';
import i18n from '../i18n';

export const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

export const maskPhoneNumber = (phone?: string): string => {
  if (!phone) {
    return '';
  }

  if (phone.search(/-/) >= 0) {
    const mask = phone.split('-');
    if (mask[1].length === 3) {
      return `${mask[0]}-***-${mask[2]}`;
    } else {
      return `${mask[0]}-***${mask[1][3]}-${mask[2]}`;
    }
  } else if (phone.length === 10) {
    return `${phone.slice(0, 2)}***${phone.slice(5, 10)}`;
  } else if (phone.length === 9) {
    if (phone[0] === '1') {
      return `${phone.slice(0, 2)}***${phone.slice(5, 9)}`;
    } else {
      return `${phone.slice(0, 1)}***${phone.slice(4, 9)}`;
    }
  }

  return phone;
};

export const translatePlaceDescription = (item: Point): string => {
  const { place: { payablePointPolicy, rewards } } = item;
  const { minimumRequiredPoint } = payablePointPolicy;
  if (minimumRequiredPoint !== null) {
    if (minimumRequiredPoint > 0) {
      return i18n.t('xP 보유시 현금처럼 사용 가능', { point: formatNumber(minimumRequiredPoint) });
    }

    return i18n.t('현금처럼 사용 가능');
  }

  if (rewards.length === 0) {
    return '';
  }

  const sortedRewards = rewards.sort((a, b) => a.cost - b.cost);
  const nearReward = sortedRewards.find(it => item.point.points < it.cost);

  if (nearReward) {
    return i18n.t(
            'xP 더 모으면 reward 교환 가능',
            { point: formatNumber(nearReward.cost - item.point.points), reward: nearReward.name },
        );
  }

  return i18n.t('n 교환 가능', { name: sortedRewards[sortedRewards.length - 1].name });
};
